export default class Pagination {
    constructor(rootSelector) {
        this.root = document.querySelector(rootSelector);
        this.prevButton = this.root.querySelector('.js_paginationPrev');
        this.nextButton = this.root.querySelector('.js_paginationNext');
        this.pagesContainer = this.root.querySelector('.js_paginationPages');

        this.state = {
            limit: 0,
            page: 0,
            count: 0,
        };

        /** Callback that's called on every button click, (page) => {} */
        this.onClick = null;

        /** Total number of page buttons in pagination, not including prev/next buttons */
        this.countPageButtons = 5;

        this._registerListeners();
    }

    _registerListeners() {
        this.prevButton.addEventListener('click', (ev) => {
            ev.preventDefault();

            if (this.state.page === 1) {
                return;
            }

            this._reportClick(--this.state.page);
        });

        this.nextButton.addEventListener('click', (ev) => {
            ev.preventDefault();

            if (this.state.page === Math.ceil(this.state.count / this.state.limit)) {
                return;
            }

            this._reportClick(++this.state.page);
        });

        this.pagesContainer.addEventListener('click', (ev) => {
            ev.preventDefault();

            if (!ev.target.dataset?.pageIndex) {
                return;
            }

            this._reportClick(parseInt(ev.target.dataset.pageIndex, 10));
        });
    }

    _createPageButton(index) {
        const button = document.createElement('button');

        button.innerText = index;
        button.dataset.pageIndex = index;
        button.classList.add('vm-button', 'vm-button--sm', 'vm-button--tertiary', 'vm-button--pagination');

        if (index === this.state.page) {
            button.setAttribute('disabled', 'disabled');
        }

        return button;
    }

    _reportClick(page) {
        if (typeof this.onClick === 'function') {
            this.onClick(page);
        }
    }

    hide() {
        this.root.classList.add('hidden');
    }

    /**
     *
     * @param { limit, page, count } state
     */
    update(state) {
        this.state = state;

        if (this.state.count <= this.state.limit) {
            this.root.classList.add('hidden');
            return;
        }

        this.root.classList.remove('hidden');

        if (this.state.page === 1) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }

        if (this.state.page === Math.ceil(this.state.count / this.state.limit)) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }

        while (this.pagesContainer.firstChild) {
            this.pagesContainer.removeChild(this.pagesContainer.firstChild);
        }

        const lowerLimit = Math.max(this.state.page - Math.floor(this.countPageButtons / 2), 1);
        const upperLimit = Math.min(
            Math.max(this.state.page + Math.floor(this.countPageButtons / 2), this.countPageButtons),
            Math.ceil(this.state.count / this.state.limit),
        );

        for (let i = lowerLimit; i <= upperLimit; ++i) {
            this.pagesContainer.appendChild(this._createPageButton(i));
        }

        this.root.classList.remove('hidden');
    }
}
